import { FormattedMessage } from 'react-intl';
import { Button } from './Button';

export const Share = ({ data }: { data: ShareData }) => {
  return (
    <Button
      color="yellow"
      onClick={() => {
        try {
          if (!('canShare' in navigator) || !navigator.canShare(data)) {
            throw new Error("Can't share");
          }
          navigator.share(data).catch((err: unknown) => {
            console.error(err);
          });
        } catch (err: unknown) {
          console.error(err);
          if (data.url) {
            navigator.clipboard.writeText(data.url).catch((err: unknown) => {
              console.error(err);
            });
          }
        }
      }}
    >
      <FormattedMessage id="share" />
    </Button>
  );
};
